<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>欠款单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="align-items: flex-start;display: flex;justify-content: flex-start;justify-items: center;text-align: center">
      <el-date-picker
        v-model="orderRequest.selectDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="欠款开始日期"
        end-placeholder="欠款结束日期"
        @change="selectKpiData"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-date-picker
        v-model="orderRequest.selectHkDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="还款开始日期"
        end-placeholder="还款结束日期"
        @change="selectHkData"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-select value filterable v-model="selectAreaId" v-if="orgLevel === 1" placeholder="请选择区域" clearable
                 style="margin-left: 5px;width: 200px" size="mini" @change="getArea">
        <el-option
          v-for="item in areas"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-if="orgLevel < 3" v-model="selectOrgId" clearable value filterable placeholder="请选择门店"
                 style="margin-left: 5px;width: 200px" size="mini" @change="getShop">
        <el-option
          v-for="org in shop"
          :key="org.id"
          :label="org.orgName"
          :value="org.id">
        </el-option>
      </el-select>
      <el-button size="mini"  style="margin-left: 5px;" @click="loadOrderData">查询</el-button>
    </div>

    <el-table height="590px" :data="orderList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333', fontWeight:700}"
              :row-style="{height: '0'}"
              >
      <el-table-column
        align="center"
        width="80px"
        label="操作"
      >
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-between">
            <el-link type="primary"  icon="iconfont icon-huankuan" title="还款" :disabled="scope.row.state === 2"
                     @click="showHkDialog(scope.row)"></el-link>
            <el-link type="primary"  icon="iconfont icon-xiangqing" title="详情"
                     @click="showDetailDialog(scope.row)"></el-link>
          </div>

        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="customerName"
        label="会员名称" width="100">
      </el-table-column>
      <el-table-column
        align="center"
        prop="arrearageDate"
        label="欠款日期" width="170">
      </el-table-column>
      <el-table-column
        align="center"
        prop="hkDate"
        label="还款日期" width="170">
      </el-table-column>
      <el-table-column
        align="center"
        prop="state"
        :formatter="stateFormatter"
        label="状态" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="arrearageMoney"
        label="欠款金额" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="moLing"
        label="抹零金额" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="sjHk"
        label="实际还款" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="payType"
        label="支付方式" width="200">
      </el-table-column>
      <el-table-column
        align="center"
        prop="shopName"
        label="消费门店" width="200">
      </el-table-column>
      <el-table-column
        align="center"
        prop="originalOrderNo"
        label="原消费单号" width="200">
      </el-table-column>
      <el-table-column
        align="center"
        prop="originalOrderId"
        label="原消费单id" width="150">
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="创建时间"
        width="180">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyTime"
        label="最后操作时间" width="150">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyName"
        label="最后操作人" width="150">
      </el-table-column>
      <el-table-column
        align="center"
        prop="isSubmit"
        label="连通用友"
        :formatter="submitFormatter">
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>

    <!-- 还款窗口 -->
    <el-dialog
      title="还款"
      :visible.sync="hkDialogVisible"
      width="60%"
      @close="closeHkDialog"
      style="position: absolute"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;margin-top: 10px;">
          <div>
            <span >应还金额：</span>
            <el-input v-model="arrOrder.arrearageMoney" readonly  placeholder="请输入内容"  size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">抹零金额：</span>
            <el-input v-model="moLing" placeholder="请输入内容" size="mini"
                      style="width: 60%;" @change="setMoLing"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">实际还款：</span>
            <el-input v-model="sjHk" readonly placeholder="请输入内容" size="mini" style="width: 60%;"/>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 5px">
        <div  style="width:100%;">
          <div style="width:75px;">支付方式：</div>
          <div  v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      :disabled="item.payEnName === 'zengsonghuiyuan' || item.payEnName == 'douyintuangou'
	                      || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
	                      || item.payEnName == 'xiaochengxutuangou' || item.payEnName === 'huiyuan'
                        || item.payEnName === 'kuaishoutuangou'"
                      @change="resetHyOrderPay" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeHkDialog">取 消</el-button>
        <el-button size="mini" @click="hk">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 还款窗口 -->
    <el-dialog
      title="详情"
      :visible.sync="detailDialogVisible"
      width="60%"
      @close="closeDetailDialog"
      style="position: absolute"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;margin-top: 10px;">
          <div>
            <span >应还金额：</span>
            <span >{{arrDetail.arrearageMoney}}</span>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">抹零金额：</span>
            <span>{{arrDetail.moLing}}</span>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">实际还款：</span>
            <span>{{arrDetail.sjHk}}</span>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;margin-top: 10px;">
          <div style="display: flex;justify-content: flex-start">
            <span >支付方式：</span>
            <div v-for="(item,index) in arrOrderPayList" :key="index" >
                <span v-if="item.payEnName ==='huiyuan'">会员：￥{{item.money}}</span>
                <span v-if="item.payEnName ==='zengsonghuiyuan'" style="margin-left: 15px;">赠送会员：￥{{item.money}}</span>
                <span v-if="item.payEnName ==='douyintuangou'" style="margin-left: 15px;">抖音团购：￥{{item.money}}</span>
                <span v-if="item.payEnName ==='meituantuangou'" style="margin-left: 15px;">美团团购：￥{{item.money}}</span>
                <span v-if="item.payEnName ==='koubeituangou'" style="margin-left: 15px;">口碑团购：￥{{item.money}}</span>
                <span v-if="item.payEnName ==='xiaochengxutuangou'" style="margin-left: 15px;">小程序团购：￥{{item.money}}</span>
                <span v-if="item.payEnName ==='kuaishoutuangou'" style="margin-left: 15px;">快手团购：￥{{item.money}}</span>
                <span v-if="item.payEnName =='posji'" style="margin-left: 15px;">pos机：￥{{item.money}}</span>
                <span v-if="item.payEnName ==='saoma'" style="margin-left: 15px;">扫码：￥{{item.money}}</span>
                <span v-if="item.payEnName ==='xianjin'" style="margin-left: 15px;">现金：￥{{item.money}}</span>
              </div>
          </div>
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeDetailDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return {
      userId:'',
      shopId:'',
      orgLevel:'',
      areas: [],
      shop:[],
      orgPayTypeList:[],
      selectOrgId:'',
      selectAreaId:'',
      orderRequest:{
        selectDate:'',
        orgId: '',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        name:'',
        state:'',
        areaId:'',
        shopId:'',
        queryOrderText:'',
        selectHkDate:'',
        startHkDate:'',
        endHkDate:'',
      },
      orderList:[],
      currentPage: 1,
      pageSize:20,
      pageTotal:0,
      stateText:[
        {state:1,name:'欠款中'},
        {state:2,name:'已还款'},
      ],
      submitText:[
        {isSubmit:1, name:'已提交'},
        {isSubmit:2, name:'未提交'},
      ],
      detailDialogVisible:false,
      hkDialogVisible:false,
      arrOrder:'',
      sjHk:'',
      moLing:'',
      arrDetail:'',
      arrOrderPayList:[]
    }
  },
  methods:{
    showDetailDialog(row){
      this.arrDetail = row;
      this.loadArrOrderPay(row.id);
      this.detailDialogVisible = true;
    },
    closeDetailDialog(){
      this.detailDialogVisible = false;
    },
    async loadArrOrderPay(arrId){
      const {data:res} = await this.$http.get(`/arr/order/pay/type/${arrId}`);
      this.arrOrderPayList = res.data;
    },
    showHkDialog(row){
      this.arrOrder = row;
      this.moLing = 0;
      this.orgPayTypeList.map((item) => {
        item.money = ''
      })
      this.setMoLing();
      this.hkDialogVisible = true;
    },
    closeHkDialog(){
      this.hkDialogVisible = false;
    },
    selectKpiData(){
      if (this.orderRequest.selectDate === null){
        this.orderRequest.startDate = '';
        this.orderRequest.endDate = '';
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }
    },
    selectHkData(){
      if (this.orderRequest.selectHkDate === null){
        this.orderRequest.startHkDate = '';
        this.orderRequest.endHkDate = '';
      } else {
        this.orderRequest.startHkDate = this.orderRequest.selectHkDate[0];
        this.orderRequest.endHkDate = this.orderRequest.selectHkDate[1];
      }
    },
    async getArea(data){
      this.orderRequest.areaId = data;
      await this.loadShop(data);
    },
    getShop(data){
      this.orderRequest.shopId = data;
      this.loadOrgPayType(data);
    },
    async loadShop(areaId){
      if (areaId !== '' ){
        const {data:res} = await this.$http.get(`/orgs/area/orgId/${areaId}`);
        this.shop = res.data;
      }
      if (areaId === ''){
        this.shop = [];
        this.selectOrgId = '';
        this.orderRequest.areaId = '';
      }
    },
    loadOrderData(){
      this.currentPage = 1;
      this.orderRequest.pageNum = this.currentPage;
      this.orderRequest.pageSize = this.pageSize;
      this.loadArrOrderCount();
      this.loadArrOrderList();
    },
    async loadArrOrderCount(){
      const {data:res} = await this.$http.post(`/arr/order/count`, this.orderRequest);
      this.pageTotal = res.totalPage;
    },
    async loadArrOrderList(){
      const {data:res} = await this.$http.post(`/arr/order/list`, this.orderRequest);
      this.orderList = res.data;
    },
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    submitFormatter(row){
      let value = "";
      for (let i = 0; i < this.submitText.length; i++){
        let item = this.submitText[i];
        if (row.isSubmit === item.isSubmit) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadArrOrderList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadArrOrderList();
    },
    async loadArea(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.shopId}`);
      if (res.code === 200){
        this.areas = res.data;
      }
    },
    async loadOrgPayType(shopId){
      const {data:res} = await this.$http.get(`/payType/orgPayType/orgId/${shopId}`)
      this.orgPayTypeList = res.data;
    },
    async hk(){
      this.arrOrder.modifier = this.userId;
      this.arrOrder.moLing = this.moLing;
      this.arrOrder.sjHk = this.sjHk;
      this.arrOrder.orderPayTypeList = this.orgPayTypeList;
      const {data:res} = await this.$http.post(`/arr/order/hk`, this.arrOrder);
      if (res.code === 200){
         this.$message.success("操作成功！");
        this.closeHkDialog();
        this.loadOrderData();
      } else {
        return this.$message.error("操作失败！");
      }
    },
    setMoLing(){
      if (this.moLing === '' || this.moLing === null){
        this.sjHk = this.arrOrder.arrearageMoney;
      } else {
        this.sjHk = this.arrOrder.arrearageMoney - parseFloat(this.moLing).toFixed(2);
      }
      this.resetHyOrderPay();
    },
    resetHyOrderPay(){

      let money = 0;
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'xianjin' && item.payEnName !== 'zengsonghuiyuan'){
          if (item.money > (this.sjHk - money)){
            item.money = (this.sjHk - money).toFixed(2);
          }
          money += item.money - 0;
        }
      })
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          if ((this.sjHk - money) < 0){
            item.money = 0;
          } else {
            item.money = (this.sjHk - money).toFixed(2);
          }
        }
      })
    },
    orderDetailStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.orderDetailStateText.length; i++){
        let item = this.orderDetailStateText[i];
        if (row.detailState === item.detailState) {
          value = item.name;
          break;
        }
      }
      return value;
    },
  },
  created(){
    this.shopId = parseInt(window.sessionStorage.getItem('currentOrgId'));
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = parseInt(window.sessionStorage.getItem('orgLevel'));
    if (this.orgLevel === 3){
      this.orderRequest.shopId = this.shopId;
      this.orderRequest.areaId = '';
      this.loadOrgPayType(this.shopId);
    }
    if (this.orgLevel === 2){
      this.orderRequest.areaId = this.shopId;
      this.loadShop(this.shopId);
      this.loadOrgPayType(this.shopId)
    }
    if (this.orgLevel === 1){
      this.loadArea();
    }
  }

}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ArrearageOrders.vue